<template>
  <form class="dropzone">
    <!-- Not displayed, just for Dropzone's `dictDefaultMessage` option -->
    <div id="dropzone-message" style="display: none">
      <span class="dropzone-title">Upload</span>
      <span class="dropzone-info"></span>
    </div>
    <v-flex xs12>
      <v-btn :disabled="disableTheButton" v-show="que" @click="processTheQueue()" class="process-btn elevation-2">
        {{btnMessage}}
        <!-- <img src="../assets/if_navigation-up-button.png" > -->
      </v-btn>
      <div v-show="que">
        These will be uploaded...
      </div>
    </v-flex>
  </form>
</template>

<script>
  import Dropzone from "dropzone";
  import "../../node_modules/dropzone/dist/dropzone.css";
  import lambda from "../lambda";
  
  Dropzone.autoDiscover = false;
  //the remove button
  Dropzone.prototype.defaultOptions.dictRemoveFile = "Remove";
  
  export default {
    methods: {
      processTheQueue() {
        let vm = this
        setTimeout(function(){ 
          vm.dropzone.processQueue();
        }, 750);
        
      }
    },
  
    name: "dropzone",
    props: ["id"],
    data() {
      return {
        que: false,
        dz: null,
        btnMessage: "Start Upload",
        disableTheButton: false
      };
    },
    mounted() {
      //move the process button outside of the dropzone...this is because i'm too lazy to properly trigger a child components method
      window.onload = function() {
        document
          .querySelector(".server-room-btns")
          .insertBefore(document.querySelector("button.process-btn"), null);
      };
  
      const vm = this;
      var thumbNail;
  
      let options = {
        acceptedFiles: "image/*",
        maxFilesize: 10,
        createImageThumbnails: true,
        addRemoveLinks: true,
        thumbnailWidth:"90",
        thumbnailHeight:"90",
        // The URL will be changed for each new file being processing
        url: "/",
  
        // Since we're going to do a `PUT` upload to S3 directly
        method: "put",
  
        // Hijack the xhr.send since Dropzone always upload file by using formData
        // ref: https://github.com/danialfarid/ng-file-upload/issues/743
        sending(file, xhr) {
          let _send = xhr.send;
          xhr.send = () => {
            _send.call(xhr, file);
          };
        },
        // Upload one file at a time since we're using the S3 pre-signed URL scenario
        parallelUploads: 1,
        uploadMultiple: false,
  
        // Content-Type should be included, otherwise you'll get a signature
        // mismatch error from S3. We're going to update this for each file.
        header: "",
  
        // Customize the wording
        dictDefaultMessage: document.querySelector("#dropzone-message").innerHTML,
  
        // We're going to process each file manually (see `accept` below)
        autoProcessQueue: false,
  
        // Here we request a signed upload URL when a file being accepted
  
        init: function() {
          //queue the file when one is added
          this.on("added", function(file) {
            this.enqueueFile(file);
          });
          //when the user begins the process, let's turn on autoqueue to process the rest of the queue
          this.on("success", function() {
            this.options.autoProcessQueue = true;
          });
          //turn auto process back off when queue is done
          this.on("queuecomplete", function() {
            this.options.autoProcessQueue = false;
            vm.que = false;
            location.reload();
          });
        }
      };
  
      // Instantiate Dropzone
      this.dropzone = new Dropzone(this.$el, options);
  
      vm.dropzone.on("thumbnail", function(file, thumb) {
        vm.que = true;
        let fileName = `vh_${file.height}_vw_${file.width}_sz_`;
        thumbNail = thumb;
        lambda
          .getSignedURLUpload(fileName, file.type, vm.id, thumbNail)
          .then(url => {
            file.uploadURL = url;
            // Manually process each file
            setTimeout(function() {
              //vm.dropzone.enqueueFile(file)
            });
          })
          .catch(err => {
            vm.btnMessage = "SERVER IS FULL";
            vm.disableTheButton = true;
          });
      });
  
      // Set signed upload URL for each file
      vm.dropzone.on("processing", file => {
        vm.dropzone.options.url = file.uploadURL;
      });
  
      vm.dropzone.on("complete", function(file) {
        vm.dropzone.removeFile(file);
      });
  
      vm.dropzone.on("removedfile", function(file) {
        if (vm.dropzone.getQueuedFiles().length) {
          vm.que = true;
        } else {
          vm.que = false;
        }
      });
  
      vm.dz = this.dropzone;
    }
  };
</script>

<style lang="stylus">
primaryBlue = #3498db;

form.dropzone {
  transition: all 0.2s linear;
  border: 5px dashed #ccc;
  background-color: #fafafa;
  min-height: initial;

  &:hover {
    border-color: black;
    background-color: white;

    .dz-message {
      .dropzone-title {
        color: primaryBlue;
      }
    }
  }

  .dz-message {
    color: #666;

    span {
      line-height: 1.8;
      font-size: 25px;
      letter-spacing: 0.4px;

      span.dropzone-title {
        display: block;
        color: #888;
        font-size: 1.25em;
      }

      span.dropzone-info {
        display: block;
        color: #a8a8a8;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Dropzone.vue